import React from 'react';
import rawMarkup from '../../util/rawMarkup';


const scriptContent = `
    var adsmtag = adsmtag || {};
    adsmtag.cmd = adsmtag.cmd || [];
`;


const DanishAdScript = () => <script type="text/javascript" dangerouslySetInnerHTML={rawMarkup(scriptContent)} />;
export default DanishAdScript;



// WEBPACK FOOTER //
// ./src/component/Page/DanishAdScript.jsx